<template>
    <div class="codes-container">
        <i class="fas fa-times" v-on:click="close" />
        <div class="codes-content">
            <div class="codes-info">
                <i class="fas fa-envelope" />
                <h4>Verificação</h4>
                <p>Enviamos pra você um código no Email, informe-os aqui para prosseguir com o saque.</p>
                <button class="button" v-if="!cooldown && cooldownTime == 0" v-on:click="resendCodes">
                    <p>{{ 'Reenviar códigos' }}</p>
                </button>
                <p class="cooldown" v-else>Você poderá reenviar o código em {{ Math.trunc(cooldownTime / 60) }}:<span v-if="cooldownTime % 60 < 10">0</span>{{(cooldownTime % 60)}}</p>
            </div>

            <div class="codes-inputs">
                <!-- <p>Código do SMS</p>
                <input v-model="smsToken" v-mask="'##########'" />
                <p class="phone">Enviado para {{ mobileNumber }}</p> -->
                <p>Código do Email</p>
                <input v-model="emailToken" v-mask="'##########'" />
                <p class="email">Enviado para {{ email }}</p>
            </div>
        </div>

        <button class="button" v-on:click="submitCodes">
			<v-progress-circular v-if="loadingCodes" color="white" size="16" indeterminate="indeterminate"></v-progress-circular>
            <p>{{ loadingCodes ? 'Enviando...' : 'Enviar' }}</p>
		</button>
    </div>
</template>
<script>
import moment from 'moment';

export default {
    props: {
        onClose: {
            type: Function,
            required: true
        },
        onValidateCodes: {
            type: Function,
            required: true
        },
        mobileNumber: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: true
        },
        cooldown: {
            type: Boolean,
            required: true
        },
        cooldownTime: {
            type: Number,
            required: true
        },
        setCooldownTime: {
            type: Function,
            required: true
        },
        timeToResendCodes: {
            type: Number,
            required: true
        },
    },

    data() {
        return {
            smsToken: null,
            emailToken: null,
            loadingCodes: false,
        }
    },

    methods: {
        close() {
            this.smsToken = null;
            this.emailToken = null;
            this.onClose();
        },

        async resendCodes() {
            try {
                let auxToken = await this.$api.dataService.execute('token/sendVerificationToken', {});
                if(auxToken){
                    this.$notifyUser({
                        type: 'success',
                        message: 'Tokens de validação enviado para Email e SMS.'
                    });
                }

                this.setCooldownTime(this.timeToResendCodes);
            } catch(err) {
                if (err.data) this.setCooldownTime(this.timeToResendCodes - moment.utc(moment().utc(-3)).diff(moment.utc(moment(err.data)), 'seconds'));

                this.$notifyUser({
                    type: 'error',
                    message: err.msg || 'Não foi possível enviar os tokens de validação.'
                });
            }
        },

        submitCodes() {
            // if (this.smsToken && this.emailToken) {
            //     this.loadingCodes = true;

            //     this.onValidateCodes({smsToken: this.smsToken, emailToken: this.emailToken});
    
            //     this.loadingCodes = false;
            // } else {
            //     this.$notifyUser({
            //         type: 'error',
            //         message: 'Preencha todos os campos para prosseguir.'
            //     });
            // }
            if (this.emailToken) {
                this.loadingCodes = true;

                this.onValidateCodes({emailToken: this.emailToken});
    
                this.loadingCodes = false;
            } else {
                this.$notifyUser({
                    type: 'error',
                    message: 'Preencha todos os campos para prosseguir.'
                });
            }
        }
    },
}
</script>
<style scoped>
    p {
        margin: 0;
    }

    .codes-container {
        width: auto;
        max-height: 550px;
        background-color: var(--background-color);
        border-radius: 10px;
        padding: 20px;
        overflow: auto;
        position: relative;
        color: var(--black-color);
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .codes-container > i {
        color: var(--primary-color);
        font-size: 22px;
        cursor: pointer;
    }

    .codes-content {
        display: flex;
        flex-direction: row;
    }

    .codes-content > div {
        flex: 1;
    }

    .codes-info > h4 {
        font-weight: bold;
        color: var(--black-color);
        margin-bottom: 5px;
    }

    .codes-info > i {
        font-size: 26px;
        color: var(--primary-color);
        margin-bottom: 10px;
    }

    .codes-inputs {
        margin-left: 25px;
    }

    .phone, .email {
        font-size: 12px;
        color: #555;
        margin-bottom: 15px;
    }

    input {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        background-color: var(--card-color);
        border-radius: 5px;
        padding: 10px 15px;
        font-size: 16px;
        outline: none;
        color: black;
    }

    .button {
        width: auto;
        padding: 7px 20px;
        border-radius: 5px;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: 0.2s;
        user-select: none;
        font-weight: bold;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--secondary-color);
        color: white;
        margin-top: 25px;
    }

    .button p {
        margin-left: 5px;
    }

    .cooldown {
        margin-top: 5px;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/CodesModal.vue